/**
 * Formatea una fecha en formato de 24 horas (hh:mm), asegurando dos dígitos.
 * 
 * @param {string|number|Date} time - Fecha o timestamp válido.
 * @returns {string} Hora formateada en formato "HH:MM".
 */
export const hourFormat = time => {
  const date = new Date(time);
  const hour = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hour}:${minutes}`;
};

/**
 * Formatea una fecha al estilo español: `DD Mes, YYYY`.
 * Ejemplo: `5 Julio, 2024`.
 * 
 * @param {string|number|Date} time - Fecha o timestamp válido.
 * @returns {string} Fecha formateada.
 */
export const dateFormatDDmesAnio = time => {
  const date = new Date(time);
  const day = date.toLocaleDateString('es-ES', { day: 'numeric' });
  const month = date
    .toLocaleDateString('es-ES', { month: 'long' })
    .replace(/^\w/, c => c.toUpperCase());
  const year = date.toLocaleDateString('es-ES', { year: 'numeric' });

  return `${day} ${month}, ${year}`;
};

/**
 * Genera un identificador de sesión aleatorio.
 * Ejemplo de salida: _5gkf93jkd
 * 
 * @returns {string} ID de sesión pseudoaleatorio.
 */
export const generateSessionId = () => {
  return `_${Math.random().toString(36).substr(2, 9)}`;
};